
import img0 from './ConfiguratorStart.png';
import img1 from './DeviceVerify.png';
import img2 from './DeviceConsent.png';
import img3 from './ConfiguratorClient.png';
import img4 from './ConfiguratorSuccess.png';
import img5 from './RegisteredClient.png';
import img6 from './ApproveClient.png';
import img7 from './ConfiguratorStartLinux.png';
import img8 from './DeviceVerify.png';
import img9 from './DeviceConsent.png';
import img10 from './ConfiguratorClientLinux.png';
import img11 from './ConfiguratorSuccessLinux.png';
import img12 from './RegisteredClientLinux.png';
import img13 from './ApproveClientLinux.png';
import img14 from './CreateClient.png';
import img15 from './ClientCredentials.png';
  
const content = `# Client Registration Overview

Prior to using the OnData Encryption Tool or any of the OnData database drivers, they have to be registered as an OnData Client in order to establish secure connectivity to 
the OnData Platform. The configuration can be done with the **OnData Configurator** utility that comes with the OnData Encryption Tool package and the OnData database driver 
packages. Below are the steps to perform the client registration on both Windows and Linux platforms.  

Under scenarios that the client registration process cannot be performed with the OnData Configurator, such as in a cloud Platform-as-a-Service environment, OnData offers an 
approach to create a client directly at the OnData Portal, and use a shared secret between the client and the OnData Portal for authentication purpose. For details on how to 
create a client with a shared secret, please refer to Section 3 below.  

Please note that a client can either be registered with the OnData Configurator, or be created directly at the OnData Portal, but not using both approaches. When possible, 
the client registration process should be used because the access credentials are protected. If a client has to be created from the OnData Portal, please make sure appropriate 
security measures are enforced to protect the client secret.  

## 1. Client Registration on Windows
a. Launch a Command Prompt and run it as administrator;  
b. Navigate to the folder where the OnData Encryption Tool or the OnData database driver is installed. The Configurator.exe should be located in that folder;  
c. Run the Configurator.exe from the command line;  
d. You will be prompted to visit an activation URL with a user code, as illustrated below;  

![Configurator Start](${ img0 })  

e. Copy the activation URL to an Internet browser and enter the user code, as illustrated below;  

![Device Verify](${ img1 })  

f. You are required to login to the OnData Portal. Sign in with your OnData account and select "Yes, Allow" to register the client;  

![Device Consent](${ img2 })  

g. Go back to Command Prompt and enter a name for the client;  

![Enter Client Name](${ img3 })  

h. The Configurator.exe should display that the client registration is completed successfully and exit itself. 

![Registration Success](${ img4 })  

i. After the client is registered, sign into the OnData Portal. Go to Settings and select Organization. Under the Clients tab, find the newly registered client, as illustrated below.  

![Registered Client](${ img5 })  

j. Select the "Review" icon on the right side, and click on the "Approve" button to activate the client.  

![Approve Client](${ img6 })  

Once the client is activated, you can start to run the OnData Encryption Tool or use the OnData database driver.  


## 2. Client Registration on Linux
a. From a Shell window, navigate to where the Configurator module is located. The Configurator module comes with the OnData Encryption Tool package and the OnData database driver 
packages;  
b. Launch the Configurator module with sudo ./Configurator-<version> command;  
c. You will be prompted to visit an activation URL with a user code, as illustrated below;  

![Configurator Start](${ img7 })  

e. Copy the activation URL to an Internet browser and enter the user code, as illustrated below;  

![Device Verify](${ img1 })  

f. You are required to login to the OnData Portal. Sign in with your OnData account and select "Yes, Allow" to register the client;  

![Device Consent](${ img2 })  

g. Go back to Command Prompt and enter a name for the client;  

![Enter Client Name](${ img10 })  

h. The Configurator.exe should display that the client registration is completed successfully and exit itself. 

![Registration Success](${ img11 })  

i. After the client is registered, sign into the OnData Portal. Go to Settings and select Organization. Under the Clients tab, find the newly registered client, as illustrated below.  

![Registered Client](${ img12 })  

j. Select the "Review" icon on the right side, and click on the "Approve" button to activate the client.  

![Approve Client](${ img13 })  

Once the client is activated, you can start to run the OnData Encryption Tool or use the OnData database driver.  
  
## 3. Client Creation with Shared Secret
An OnData client can be directly created at the OnData Portal. Below are the steps to create such a client:  
a. Login to the OnData Portal and click on the Settings icon on the top right corner;  
b. Select "Organization" from the dropdown menu, and select the "Clients" tab on the Organization Settings page;  
c. Click on the "Add New..." button. Provide a name for the client and optionally a description for the client as well, then click on the "Save" button;  

![Create Client](${ img14 })  

d. A client is created with both the "Client ID" and "Client Secret" displayed. Please copy the Client Secret and save it to somewhere safe. OnData will only display it once.  

![Client Credentials](${ img15 })  

e. The Client ID and Client Secret can be used in client configuration files, such as the OnDataDriver.config file for the OnData Drivers, or the appsettings.ini file for the 
OnData Encryption Tool. An example is provided below:  

  \`\`\`bash
  DatabaseType = POSTGRESQL
  DriverFullPath = /usr/lib/x86_64-linux-gnu/odbc/psqlodbcw.so
  ClientId = <Client ID from OnData Portal>
  ClientSecret = <Client Secret from OnData Portal>
  \`\`\`
  `
  
export default content;
